import React from 'react';
import { useHistory } from 'react-router-dom';
import { ROUTES } from '../../routing';
import { useGetProsumerProfile } from '../../hooks/use-hydra';
import Navbar from '../../components/Navbar';
import styled from 'styled-components';
import PageWithAsyncData from '../../components/PageWithAsyncData';
import * as Analytics from '../../analytics';
import { EVENTS } from '../../analytics';
import BenefitsContent from '../../components/Benefits';

const PageWrapper = styled(PageWithAsyncData)`
  display: flex;
  flex-direction: column;
  padding: 0;
  margin: 0;
`;

export default function Benefits() {
  Analytics.useTrackViewOnMount(EVENTS.PROSUMER.UPSELL.VIEW_BENEFITS, {
    flowType: 'logged_in',
  });

  const history = useHistory();
  const {
    value: profileValue,
    loading: isLoadingProfile,
    error,
    retry,
  } = useGetProsumerProfile();
  const { hasAccess } = profileValue?.learnMode || {};

  React.useEffect(() => {
    if (!profileValue || hasAccess) {
      history.push(ROUTES.HOME.getPath());
    }
  }, [hasAccess, profileValue, history]);

  return (
    <PageWrapper
      isLoading={isLoadingProfile}
      className={''}
      error={error}
      retry={retry}
    >
      <Navbar />
      <BenefitsContent
        onNext={() => {
          history.push(ROUTES.PROSUMER.PAYMENT.getPath());
          window.scrollTo(0, 0);
        }}
      />
    </PageWrapper>
  );
}
